(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giveaway-entry"] && !Shopify.designMode) return;
  try {
    
  class GiveawayForm extends HTMLElement {
    static klaviyoRevision = '2026-07-15';

    connectedCallback() {
      if (this.form) return;

      this.form = this.querySelector('.giveaway-form__form');
      this.entryPanel = this.querySelector('[data-entry]');
      this.successPanel = this.querySelector('[data-success]');
      this.errorMessage = this.querySelector('[data-error]');
      this.confirmation = this.querySelector('[data-confirmation]');
      this.submitButton = this.form.querySelector('[type="submit"]');

      const { phone_number: phone, sms_consent: smsConsent } = this.form.elements;
      smsConsent.addEventListener('change', () => {
        phone.required = smsConsent.checked;
      });

      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      this.confirmation.addEventListener('close', () => this.successPanel.focus());
    }

    async handleSubmit(event) {
      event.preventDefault();
      this.errorMessage.textContent = '';
      this.setBusy(true);
      this.preloadConfirmation();

      try {
        await this.submitEntry(new FormData(this.form));
        this.showSuccess();
      } catch (error) {
        console.error('Giveaway entry failed:', error);
        this.errorMessage.textContent = this.errorMessage.dataset.message;
      } finally {
        this.setBusy(false);
      }
    }

    /**
     * Every entry is recorded as a "Giveaway Entry" event (deduplicated per email).
     * Only entrants who tick an opt-in are subscribed to the list, on the channels they chose.
     */
    async submitEntry(data) {
      const { klaviyoKey, klaviyoList, giveaway } = this.dataset;
      if (!klaviyoKey || !klaviyoList) throw new Error('Klaviyo public API key or list ID is missing.');

      const email = data.get('email').trim();
      const emailConsent = data.has('email_consent');
      const smsConsent = data.has('sms_consent');
      const profile = {
        email,
        first_name: data.get('first_name').trim() || undefined,
        phone_number: this.toE164(data.get('phone_number')),
      };

      const requests = [
        this.sendToKlaviyo('events', {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Giveaway Entry' } } },
            profile: { data: { type: 'profile', attributes: profile } },
            properties: { giveaway, email_marketing_opt_in: emailConsent, sms_marketing_opt_in: smsConsent },
            unique_id: `${giveaway}:${email.toLowerCase()}`,
          },
        }),
      ];

      if (emailConsent || smsConsent) {
        const subscriptions = {};
        if (emailConsent) subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
        if (smsConsent) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };

        requests.push(
          this.sendToKlaviyo('subscriptions', {
            type: 'subscription',
            attributes: {
              custom_source: giveaway,
              profile: { data: { type: 'profile', attributes: { ...profile, subscriptions } } },
            },
            relationships: { list: { data: { type: 'list', id: klaviyoList } } },
          })
        );
      }

      await Promise.all(requests);
    }

    async sendToKlaviyo(endpoint, data) {
      const url = `https://a.klaviyo.com/client/${endpoint}?company_id=${encodeURIComponent(this.dataset.klaviyoKey)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: GiveawayForm.klaviyoRevision },
        body: JSON.stringify({ data }),
      });

      if (!response.ok) throw new Error(`Klaviyo ${endpoint} responded ${response.status}: ${await response.text()}`);
    }

    /** The phone field's pattern only accepts US numbers, so 10 digits get the +1 country code. */
    toE164(value) {
      const digits = value.replace(/\D/g, '');
      if (!digits) return undefined;
      return digits.length === 10 ? `+1${digits}` : `+${digits}`;
    }

    /** Lets the confirmation images download during the request instead of after it. */
    preloadConfirmation() {
      this.confirmation.querySelectorAll('img[loading="lazy"]').forEach((image) => {
        image.loading = 'eager';
      });
    }

    setBusy(busy) {
      this.submitButton.disabled = busy;
      this.form.setAttribute('aria-busy', String(busy));
    }

    showSuccess() {
      this.entryPanel.hidden = true;
      this.successPanel.hidden = false;
      this.confirmation.showModal();
    }
  }

  if (!customElements.get('giveaway-form')) {
    customElements.define('giveaway-form', GiveawayForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-marquee"] && !Shopify.designMode) return;
  try {
    
  class GiveawayMarquee extends HTMLElement {
    static storageKey = 'avf:motion-paused';

    connectedCallback() {
      if (this.toggle) return;

      this.toggle = this.querySelector('.giveaway-marquee__toggle');
      this.toggle.addEventListener('click', () => this.setPaused(!this.paused, true));

      const stored = this.storedPreference();
      this.setPaused(stored ?? matchMedia('(prefers-reduced-motion: reduce)').matches, stored !== null);
    }

    get paused() {
      return this.toggle.getAttribute('aria-pressed') === 'true';
    }

    storedPreference() {
      try {
        const value = sessionStorage.getItem(GiveawayMarquee.storageKey);
        return value === null ? null : value === 'true';
      } catch {
        return null;
      }
    }

    setPaused(paused, explicit) {
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);

      if (!explicit) return;

      this.dataset.state = paused ? 'paused' : 'running';
      try {
        sessionStorage.setItem(GiveawayMarquee.storageKey, String(paused));
      } catch {}
    }
  }

  if (!customElements.get('giveaway-marquee')) {
    customElements.define('giveaway-marquee', GiveawayMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
